import { defineStore } from 'pinia'
import { ref } from 'vue'

export const contextMenuOptionsShowStatesStore = (id: string) =>
  defineStore(id, () => {
    const visible = ref<boolean>(false)

    function czyPokazac() {
      return visible.value
    }

    function setVisible(new_state: boolean) {
      visible.value = new_state
    }

    function toggleVisible() {
      hideAll()
      setVisible(true)
    }

    return { czyPokazac, setVisible, toggleVisible }
  })

export const wasCleaned = ref<boolean>(false)

export const hideAll = () => {
  if (wasCleaned.value) {
    return
  }
  useImageContextMenuOptionsShowStatesStore().setVisible(false)
  useVideoContextMenuOptionsShowStatesStore().setVisible(false)
  useLinkContextMenuOptionsShowStatesStore().setVisible(false)
  useCustomComponentContextMenuOptionsShowStatesStore().setVisible(false)
  useCustomComponentListContextMenuOptionsShowStatesStore().setVisible(false)
  useComponentListBlockContextMenuOptionsShowStatesStore().setVisible(false)
  wasCleaned.value = true
}

export const useImageContextMenuOptionsShowStatesStore = contextMenuOptionsShowStatesStore('imageContextMenuShowStates')
export const useVideoContextMenuOptionsShowStatesStore = contextMenuOptionsShowStatesStore('videoContextMenuShowStates')
export const useLinkContextMenuOptionsShowStatesStore = contextMenuOptionsShowStatesStore('linkContextMenuShowStates')
export const useCustomComponentContextMenuOptionsShowStatesStore = contextMenuOptionsShowStatesStore('customComponentContextMenuStoreShowStates')
export const useCustomComponentListContextMenuOptionsShowStatesStore = contextMenuOptionsShowStatesStore('customComponentListContextMenuStoreShowStates')
export const useComponentListBlockContextMenuOptionsShowStatesStore = contextMenuOptionsShowStatesStore('componentListBlockContextMenuStoreShowStates')
